import ApplicationSerializer from 'frontend-payments/serializers/application';

export default class BillingAdminSerializer extends ApplicationSerializer {
  primaryKey = 'contact_id';

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  payloadKeyFromModelName() {
    return 'billing_admin';
  }
}
